<template>
<div class="container">
  <div class="row">
    <div class="col-12 col-lg-9">
      <h2 class="mt-4 mb-3">
        Výsledky závodníka
        <select v-model="person" class="inline-select">
          <option
                  v-for="person in people"
                  :key="person"
                  :value="person">{{ person }}
          </option>
        </select>
      </h2>
      <div class="table-responsive">
        <table class="table table-bordered">
          <table-header v-model="sort" hide-name/>
          <tr
                  v-for="result in sortedPersonResults"
                  :key="result.year"
                  @click="selectedResult === result ? selectedResult = null : selectedResult = result"
                  :class="{'table-active': selectedResult === result}">
            <td>
              <base-medal :order="result.order" lg/>
            </td>
            <td class="text-nowrap">
              <router-link :to="{name: 'results', params: {year: result.year}}" @click.native.stop.prevent="" class="text-primary">
                {{ result.year }} <span class="text-secondary">({{ result.year | yearToSeason }}. ročník)</span>
              </router-link>
            </td>
            <time-comparison-cell :order="result.swimOrder" :actual="result.swim"
                                  :target="selectedResult && selectedResult.swim"/>
            <time-comparison-cell :order="result.bikeOrder" :actual="result.bike"
                                  :target="selectedResult && selectedResult.bike"/>
            <time-comparison-cell :order="result.afterBikeOrder" :actual="result.afterBike"
                                  :target="selectedResult && selectedResult.afterBike"/>
            <time-comparison-cell :order="result.runOrder" :actual="result.run"
                                  :target="selectedResult && selectedResult.run"/>
            <time-comparison-cell :actual="result.total" :target="selectedResult && selectedResult.total"/>
          </tr>
        </table>
        <p class="text-primary"><strong><base-icon icon="info-circle"/> TIP:</strong> Pro srovnání časů v jednotlivých ročnících klikněte na řádek tabulky.</p>
      </div>

      <h2 class="mt-4 mb-3">Graf časů za jednotlivé ročníky</h2>
      <line-chart :results="personResults"/>
    </div>
    <div class="col-12 col-lg-3">
      <h2 class="mt-4 mb-3">Statistiky</h2>
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-12">
          <div class="mb-4">
            <base-statistics :value="statistics.gold" text="Zlato" variant="gold">
              <base-medal :order="1" lg/>
            </base-statistics>
            <base-statistics :value="statistics.silver" text="Stříbro" variant="silver">
              <base-medal :order="2" lg/>
            </base-statistics>
            <base-statistics :value="statistics.bronze" text="Bronz" variant="bronze">
              <base-medal :order="3" lg/>
            </base-statistics>
            <base-statistics icon="trophy" :value="statistics.trophy" text="Na poháru"/>
          </div>
          <div class="mb-4">
            <base-statistics icon="calculator" :value="statistics.participations + '/' + yearsCount" text="Účastí"/>
          </div>
        </div>
        <div class="col-12 col-sm-6 col-lg-12">
          <div class="mb-4">
          <base-statistics icon="fire-alt" :value="statistics.best + '.'" text="Nejlepší umístění" variant="danger"/>
          <base-statistics icon="swimmer" :value="statistics.bestSwim + '.'" text="Nejlepší plavání" variant="swim"/>
          <base-statistics icon="biking" :value="statistics.bestBike + '.'" text="Nejlepší kolo" variant="bike"/>
          <base-statistics icon="running" :value="statistics.bestRun + '.'" text="Nejlepší běh" variant="run"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
    import TimeComparisonCell from "@/components/TimeComparisonCell";
    import BaseMedal from "@/components/BaseMedal";
    import BaseStatistics from "@/components/BaseStatistics";
    import LineChart from "@/components/LineChart";
    import TableHeader from "@/components/TableHeader";
    import utils from "@/utils";

    export default {
      name: "PersonPage",
      components: {TableHeader, LineChart, BaseStatistics, BaseMedal, TimeComparisonCell},
      data() {
        return {
          person: this.$route.params.person,
          selectedResult: null,
          sort: {
            property: "year",
            asc: false
          }
        };
      },
      computed: {
        personResults() {
          return this.$store.getters.resultsByPerson(this.person);
        },
        sortedPersonResults() {
          const results = this.personResults;
          results.sort(utils.createSortByProperty(this.sort.property, this.sort.asc));
          return results;
        },
        people() {
          return this.$store.getters.people;
        },
        yearsCount() {
          return this.$store.getters.yearsCount;
        },
        statistics() {
          const DEFAULT_STATISTICS = {
            gold: 0,
            silver: 0,
            bronze: 0,
            trophy: 0,
            best: 999,
            participations: 0,
            bestSwim: 999,
            bestBike: 999,
            bestRun: 999,
          };
          return this.personResults.reduce((statistics, result) => ({
            gold: statistics.gold + (result.order === 1 ? 1 : 0),
            silver: statistics.silver + (result.order === 2 ? 1 : 0),
            bronze: statistics.bronze + (result.order === 3 ? 1 : 0),
            trophy: statistics.trophy + (result.order <= 10 ? 1 : 0),
            participations: statistics.participations + 1,
            best: result.order < statistics.best ? result.order : statistics.best,
            bestSwim: result.swimOrder < statistics.bestSwim ? result.swimOrder : statistics.bestSwim,
            bestBike: result.bikeOrder < statistics.bestBike ? result.bikeOrder : statistics.bestBike,
            bestRun: result.runOrder < statistics.bestRun ? result.runOrder : statistics.bestRun,
          }), DEFAULT_STATISTICS);
        }
      },
      watch: {
        person(newValue, oldValue) {
          if (newValue !== oldValue) {
            this.selectedResult = null;
          }
        }
      },
    };
</script>